<template>
  <v-switch
    v-if="config.as === 'switch'"
    v-model="booleanValue"
    :required="config.required"
    :label="config.label"
    dark>
  </v-switch>
  <v-checkbox
    v-else
    v-model="booleanValue"
    :required="config.required"
    :label="config.label"
    dark>
  </v-checkbox>
</template>

<script>
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    data () {
      return {
        booleanValue: this.value === true
      }
    },
    watch: {
      booleanValue () {
        this.emit(this.booleanValue)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Boolean.vue